<template>
    <div class="banner">
        <avideo :srcs="['/assets/banners/roulette.webm','/assets/banners/roulette.mp4']" poster="/assets/banners/roulette.jpg"/>        
        <div class="inner">
            <div class="container">
                <div class="title" v-html="$t('banners.roulette.title')"></div>
                <div class="text">{{$t('banners.roulette.text')}}</div>
                <router-link class="button button-lg" to="/#number-games">{{$t('banners.roulette.button')}} <i class="icon-arrow_right_alt" /></router-link>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'BannerRoulette'
}
</script>

<style lang="scss" scoped>
    .title {
        font-size: 1rem;
        text-transform: uppercase;
        text-shadow: 1px 3px 0 $black, 1px 3px 5px $black;
    }

    .text {
        display: block;
        font-size: 4rem;
        text-shadow: 0 0 80px rgba(255, 255, 255, 0.5);
        background: url(/assets/animated_text_fill.png) repeat-y;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        -webkit-animation: aitf 80s linear infinite;
        -webkit-transform: translate3d(0, 0, 0);
        -webkit-backface-visibility: hidden;
        text-transform: uppercase;

        @keyframes aitf {
            0% {
                background-position: 0% 50%;
            }

            100% {
                background-position: 100% 50%;
            }
        }
    }

    .button {
        margin-top: $spacer*2;
    }

    @media all and (-ms-high-contrast:none) {
        .text {
            background: none;
        }
        *::-ms-backdrop, .text {
            background: none;
        }
    }
</style>
